import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import BaseDialog from "../ui/BaseDialog";
import ActionButton from "../ui/ActionButton";

// modal to reaffirm the user's decision to refresh the page (cancel/refresh)
const SaveChangesModal = ({ open, onClose, onConfirm, darkMode }) => {
  const { t } = useTranslation();

  return (
    <BaseDialog
      open={open}
      onClose={onClose}
      title={t("Unsaved Changes")}
      darkMode={darkMode}
      ariaLabelledBy="save-changes-modal-title"
      ariaDescribedBy="save-changes-modal-description"
      actions={
        <>
          <ActionButton onClick={onClose} variant="default" modal>
            {t("Cancel")}
          </ActionButton>
          <ActionButton onClick={onConfirm} variant="danger" modal>
            {t("Refresh")}
          </ActionButton>
        </>
      }
    >
      {/* message */}
      <Typography
        sx={{
          fontFamily: "Poppins",
          fontSize: "1rem",
          color: darkMode ? "#e0e0e0" : "#666666",
          textAlign: "center",
        }}
      >
        {t(
          "You have unsaved changes. Refreshing will discard them. Continue?"
        )}
      </Typography>
    </BaseDialog>
  );
};

SaveChangesModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  darkMode: PropTypes.bool.isRequired,
};

export default SaveChangesModal;